import { call, put, takeLatest } from 'redux-saga/effects'
import { api } from '~/services/api'
import {
  addMaintenanceSuccess,
  addMaintenanceFailed,
  ADD_MAINTENANCE_START,
} from '~/views/app/redux/actions/maintenance'

/**
 * create maintenance api
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const createMaintenanceApi = (params) => {
  const uri = `/maintenances`
  return api.post(uri, params)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doCreateMaintenance(action) {
  try {
    const response = yield call(createMaintenanceApi, action?.payload)
    if (response?.statusCode !== 400) {
      yield put(addMaintenanceSuccess(response?.data))

      // Call callback action if provided
      if (action.onSuccess) {
        yield action.onSuccess(response?.data)
      }
    } else {
      throw response?.message
    }
  } catch (error) {
    yield put(addMaintenanceFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch create maintenance request
 */
export default function* watchCreateMaintenance() {
  yield takeLatest(ADD_MAINTENANCE_START, doCreateMaintenance)
}
